import React from "react";
import { Icon } from "../core/Icon.jsx";

/* Tabs — underline style. items: [{id,label,icon?,count?}]. */
export function Tabs({ items = [], active, onChange, style, tabIndex, ...rest }) {
  return (
    <div
      role="tablist"
      style={{
        display: "flex",
        gap: 4,
        borderBottom: "1px solid var(--divider)",
        ...style,
      }}
      {...rest}
    >
      {items.map((t) => (
        <Tab key={t.id} tab={t} active={active === t.id} onChange={onChange} tabIndex={tabIndex} />
      ))}
    </div>
  );
}

function Tab({ tab, active, onChange, tabIndex }) {
  const [hover, setHover] = React.useState(false);
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      tabIndex={tabIndex}
      onClick={() => onChange && onChange(tab.id)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        height: 42,
        padding: "0 14px",
        border: "none",
        background: "transparent",
        cursor: "pointer",
        fontFamily: "var(--font-sans)",
        fontWeight: active ? 700 : 500,
        fontSize: 14,
        color: active ? "var(--text-strong)" : hover ? "var(--text-body)" : "var(--text-muted)",
        position: "relative",
        transition: "color var(--dur) var(--ease)",
      }}
    >
      {tab.icon ? <Icon name={tab.icon} size={18} /> : null}
      {tab.label}
      {tab.count != null ? (
        <span style={{
          fontSize: 11, fontWeight: 700, padding: "2px 7px", borderRadius: "var(--radius-pill)",
          background: active ? "var(--mint-light)" : "var(--grey-bg)",
          color: active ? "var(--green-success)" : "var(--text-muted)",
        }}>{tab.count}</span>
      ) : null}
      <span style={{
        position: "absolute", left: 8, right: 8, bottom: -1, height: 3, borderRadius: "3px 3px 0 0",
        background: active ? "var(--green-bright)" : "transparent",
        transition: "background var(--dur) var(--ease)",
      }} />
    </button>
  );
}

export default Tabs;
